/* eslint-disable import/prefer-default-export */
import axios from 'axios';

import { getEEBaseUrl } from './utils';

import { EE_ASSET_LIST_VIDEO_PATH } from './constants';

export const getCameraOnTimeIntervals = (queryParams) => {
  const baseUrl = getEEBaseUrl();
  const url = baseUrl + EE_ASSET_LIST_VIDEO_PATH;
  return axios
    .get(url, {
      params: queryParams,
    })
    .then(
      (res) => res,
      (err) => err,
    );
};
